import "../bootstrap.js";

import QuickApplyModalContent from "../components/QuickApplyModalContent.vue";
import {createApp, markRaw} from "vue";
import {createPinia} from "pinia";
import setupSentry from "../helpers/SetupSentry.js";
import {router} from "../routes/routes.js";
import Toast from "vue-toastification";
import {toastOptions} from "../config/toastOptions.js";
import "../../css/toast-message.css";
import {gtagOpportunityViewed} from "../helpers/GoogleAnalytics.js";

localStorage.theme = "light";

const pinia = createPinia();
const app = createApp(QuickApplyModalContent);

const sentryDsn = import.meta.env.VITE_SENTRY_DSN_PUBLIC;
if (sentryDsn) setupSentry(sentryDsn, app, router);

pinia.use(({store}) => {
  store.router = markRaw(router);
});

app.use(pinia);
app.use(Toast, toastOptions);

app.mount("#quick-apply-modal-content");
gtagOpportunityViewed(window.location.pathname.split("/")[2]);
